import React, { useState } from 'react';
import { useAuth } from '../../utils/authService';
import { Link, useNavigate } from "react-router-dom";
import GoogleLogo from '../../assets/google.png';
import { doc, setDoc, collection, getDoc } from "firebase/firestore"; 
import { db } from '../../utils/firebase-config';

const SignIn = () => {
  const { signin, signInWithGoogle } = useAuth();
  const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
      e.preventDefault()
      await signin(email, password)
          .then((userInfo) => {
              const currentUser = userInfo.user
              console.log(currentUser)
              navigate('/profile')
          })
          .catch((error) => {
              console.log(error)
          })
  }

  const handleGoogleSignIn = async () => {
    try {
      const userInfo = await signInWithGoogle();
      const user = userInfo.user;
  
      // Reference to Firestore user document
      const userRef = doc(db, "users", user.uid);
  
      // Default user profile (for new users)
      const defaultUserProfile = {
        email: user.email || "",
        firstName: user.displayName?.split(" ")[0] || "First Name",
        lastName: user.displayName?.split(" ")[1] || "Last Name",
        aboutMe: "This is a returning user.",
        dateOfBirth: "", // This can be updated in the profile page
        username: "",
        image: user.photoURL || "",
        bio: "",
        displayName: user.displayName || "",
        masterclassCompleted: false,
        masterClassSubStep: 0,
        currentStep: 0,
        progress: {
          "Masterclass": 0,
          "Finances & Philanthropy": 2,
          "Entrepreneurship & Philanthropy": 8,
          "Community-Minded Business Concept Form": 12,
          "Wealth Building Stage": 21,
        },
      };
  
      // Fetch existing user data
      const docSnap = await getDoc(userRef);
  
      if (docSnap.exists()) {
        const existingData = docSnap.data();
  
        // Merge default fields with existing fields, preserving progress
        const mergedData = {
          ...defaultUserProfile,
          ...existingData, // Existing fields take precedence
          progress: {
            ...defaultUserProfile.progress, // Default progress
            ...existingData.progress, // Preserve existing progress
          },
        };
  
        // Update the Firestore document
        await setDoc(userRef, mergedData, { merge: true });
      } else {
        // Create a new profile if the user doesn't exist
        await setDoc(userRef, defaultUserProfile);
      }
  
      // Navigate to the profile page after signing in
      navigate('/profile');
    } catch (error) {
      console.error("Google Sign-In error:", error);
    }
  };
  
  

  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-md px-8 py-6 mt-4 text-left bg-white shadow-lg">
        <h3 className="text-2xl font-bold text-center">Sign in to your account</h3>
        <button onClick={handleGoogleSignIn} className="bg-gray-200 text-black ml-auto mr-auto mt-5 font-semibold py-3 px-6 rounded-2xl flex items-center space-x-2">
          Sign In with Google  
          <img 
                src={GoogleLogo} 
                alt="Google Logo" 
                className="w-6 h-6 ml-2" 
            />
        </button>
        <form onSubmit={handleSubmit}>
          <div className="mt-4">
            <div>
              <label className="block" htmlFor="email">Email</label>
              <input type="email" placeholder="Email"
                     className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
                     value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="mt-4">
              <label className="block" htmlFor="password">Password</label>
              <input type="password" placeholder="Password"
                     className="w-full px-4 py-2 mt-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"
                     value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <div className="flex items-baseline justify-between">
              <button type="submit" className="px-6 py-2 mt-4 orange-bg font-semibold rounded-full hover:bg-amber-600 transition-colors" onClick={(e) => { handleSubmit(e) }}>Sign In</button>
              <a href="#" className="text-sm text-blue-600 hover:underline">Forgot password?</a>
              <Link to='/signup'>Sign up?</Link>
            </div>
          </div>
        </form>
   
        
      </div>
    </div>
  );
};

export default SignIn;
